import { createTheme } from "@mui/material";

import { CUSTOM_COMPONENTS } from "./components";
import { CUSTOM_PALETTE } from "./palette";
import { CUSTOM_SHADOWS } from "./shadows";
import { CUSTOM_TYPOGRAPHY } from "./typography";

export const theme = createTheme({
  cssVariables: true,
  typography: CUSTOM_TYPOGRAPHY,
  // TODO: do we need this mixins/toolbar?
  mixins: {
    toolbar: {
      minHeight: "60px",
    },
  },
  shape: {
    borderRadius: 8,
  },
  shadows: CUSTOM_SHADOWS,
  components: CUSTOM_COMPONENTS,
  colorSchemes: {
    light: {
      palette: CUSTOM_PALETTE,
    },
  },
});
